import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SettingsState } from '@app/shared';

const getSettingsFeatureState = createFeatureSelector<SettingsState>('settings');

const getSettings = createSelector(getSettingsFeatureState, (state) => state.settings);

const getDashboardsUrl = createSelector(getSettings, (settings) => settings?.dashboards?.url);

const getApiSettings = createSelector(getSettings, (settings) => settings.api);

const getApiRegistry = createSelector(getSettingsFeatureState, (state) => state.registryRecords);

const getUserType = createSelector(getSettingsFeatureState, (state) => state.userType);

const getContentUrl = createSelector(getSettings, (settings) => settings?.content?.url);

const getContentV3Url = createSelector(getSettings, (settings) => settings?.contentV3?.url);

const getCloudFrontUrl = createSelector(
  getSettings,
  (settings) => settings?.content?.cloudFrontUrl,
);

const getVideoTemplateId = createSelector(
  getSettings,
  (settings) => settings?.content?.videoTemplateId,
);

const getResourcesUrl = createSelector(getSettings, (settings) => settings?.resources?.url);

const getFusionSettings = createSelector(getSettings, (settings) => settings?.fusion);

const getHelpMessages = createSelector(getSettings, (settings) => settings?.helpMessages);

const getSentrySettings = createSelector(getSettings, (settings) => settings?.sentry);

const websocketUrl = createSelector(
  getSettings,
  (settings) => settings?.notifications?.websocketUrl,
);

const getVersion = createSelector(getSettings, (settings) => settings.version);

const getAhaSettings = createSelector(getSettings, (settings) => settings.aha);

const getAmazonConnectSettings = createSelector(getSettings, (settings) => settings.amazonConnect);

export const settingsSelectors = {
  getSettings,
  getDashboardsUrl,
  getApiSettings,
  getApiRegistry,
  getUserType,
  getContentUrl,
  getContentV3Url,
  getCloudFrontUrl,
  getVideoTemplateId,
  getResourcesUrl,
  getFusionSettings,
  getHelpMessages,
  getSentrySettings,
  websocketUrl,
  getVersion,
  getAhaSettings,
  getAmazonConnectSettings,
};
